
import { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types';
import { CircularProgress, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ModalFinalizarChat from 'src/components/_chats/chat/components/ModalFinalizarChat';
import ModalBloquearChat from 'src/components/_chats/chat/components/ModalBloquearChat';
import ModalTransferirChat from 'src/components/_chats/chat/components/ModalTransferirChat';
import ModalFunilChat from 'src/components/_chats/chat/components/ModalFunilChat';
import ModalCall from 'src/components/_chats/chat/components/ModalCall';
import DrawerAgendamentos from 'src/components/_chats/agendamentos/DrawerAgendamentos';

import { useDispatch, useSelector } from 'src/redux/store';
import { getChatsPendente, getChatsAtendimento, getChatsFinalizados, getListaFunil, getCountsChats, setChatInfo, removeChatFromList, setMessagesWhatsapp, getMensagensWhatsapp, bloquearChat, desbloquearChat } from 'src/redux/slices/chat';
import { getListaSetoresTransferencia, getListaUsuariosTransferencia } from 'src/redux/slices/user';
import useAuth from 'src/hooks/useAuth';
import { PATH_CHAT } from 'src/routes/paths';
import { formataNumeroCelular } from 'src/utils/functions';
import Iconify from 'src/components/Iconify';
import { useSnackbar } from 'notistack';
import v1_actionBuscarMensagensWhatsapp from 'src/actions/v1/whatsapp/v1_actionBuscarMensagensWhatsapp';
import getActionAceitarChat from 'src/actions/chats/getActionAceitarChat';
import getActionCriarFunil from 'src/actions/chats/getActionCriarFunil';
import { setMessages } from 'src/redux/slices/staff';
import { Button } from 'src/@/components/ui/button';
import v2_actionFinalizarChat from 'src/actions/v2/chats/v2_actionFinalizarChat';
import v2_actionTransferChatInit from 'src/actions/v2/chats/v2_actionTransferChatInit';
import actionCriarNotas from 'src/actions/chats/notas/actionCriarNotas';
import ModalLightbox from 'src/@/components/shared/ModalLightbox';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu";
import { Input } from "src/@/components/ui/input";
import { Card } from "src/@/components/ui/card";
import v2_useResponsive from 'src/hooks/v2_useResponsive';

// ----------------------------------------------------------------------

const CANAL_ICONS = {
  whatsapp: { icon: 'ic:round-whatsapp', color: 'text-emerald-600 dark:text-emerald-400', bg: 'bg-emerald-50 dark:bg-emerald-500/10' },
  whatsapp_business: { icon: 'ic:round-whatsapp', color: 'text-emerald-600 dark:text-emerald-400', bg: 'bg-emerald-50 dark:bg-emerald-500/10' },
  instagram: { icon: 'mdi:instagram', color: 'text-pink-600 dark:text-pink-400', bg: 'bg-pink-50 dark:bg-pink-500/10' },
  facebook: { icon: 'ic:round-facebook', color: 'text-blue-600 dark:text-blue-400', bg: 'bg-blue-50 dark:bg-blue-500/10' },
  telegram: { icon: 'ic:round-telegram', color: 'text-sky-600 dark:text-sky-400', bg: 'bg-sky-50 dark:bg-sky-500/10' },
};

// ----------------------------------------------------------------------

const MobileMenu = ({ onFinalize, onTransfer, onSchedule, onCatch, onCall, onBlock, chat, user }) => {
  const { t } = useTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 text-gray-500 dark:text-neutral-400 hover:bg-gray-100 dark:hover:bg-neutral-800 rounded-lg"
        >
          <Iconify icon="solar:menu-dots-bold" width={18} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        <DropdownMenuGroup>
          {chat.statusRoom !== "Finalizado" && (
            <DropdownMenuItem onClick={onFinalize} className="cursor-pointer gap-2.5">
              <div className="w-7 h-7 rounded-lg bg-red-50 dark:bg-red-500/10 flex items-center justify-center flex-shrink-0">
                <Iconify icon="mdi:chat-remove" width={14} className="text-red-500" />
              </div>
              <span className="text-sm">{t('chat.header.finalize')}</span>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={onTransfer} className="cursor-pointer gap-2.5">
            <div className="w-7 h-7 rounded-lg bg-blue-50 dark:bg-blue-500/10 flex items-center justify-center flex-shrink-0">
              <Iconify icon="mingcute:transfer-fill" width={14} className="text-blue-500" />
            </div>
            <span className="text-sm">{t('chat.header.transfer')}</span>
          </DropdownMenuItem>
          {user.level === 'root' && (
            <DropdownMenuItem onClick={onCatch} className="cursor-pointer gap-2.5">
              <div className="w-7 h-7 rounded-lg bg-amber-50 dark:bg-amber-500/10 flex items-center justify-center flex-shrink-0">
                <Iconify icon="fa-solid:hand-rock" width={14} className="text-amber-500" />
              </div>
              <span className="text-sm">{t('chat.header.catchChat')}</span>
            </DropdownMenuItem>
          )}
          {chat.canal === "whatsapp" && (
            <DropdownMenuItem onClick={onSchedule} className="cursor-pointer gap-2.5">
              <div className="w-7 h-7 rounded-lg bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center flex-shrink-0">
                <Iconify icon="solar:calendar-bold" width={14} className="text-violet-500" />
              </div>
              <span className="text-sm">{t('chat.header.scheduleShort')}</span>
            </DropdownMenuItem>
          )}
          {["whatsapp", "whatsapp_business"].includes(chat.canal) && (
            <DropdownMenuItem onClick={onCall} className="cursor-pointer gap-2.5">
              <div className="w-7 h-7 rounded-lg bg-emerald-50 dark:bg-emerald-500/10 flex items-center justify-center flex-shrink-0">
                <Iconify icon="solar:phone-bold" width={14} className="text-emerald-500" />
              </div>
              <span className="text-sm">{t('chat.header.call')}</span>
            </DropdownMenuItem>
          )}
          {["whatsapp", "whatsapp_business"].includes(chat.canal) && (
            <DropdownMenuItem onClick={onBlock} className="cursor-pointer gap-2.5">
              <div className="w-7 h-7 rounded-lg bg-red-50 dark:bg-red-500/10 flex items-center justify-center flex-shrink-0">
                <Iconify
                  icon={chat.bloqueado ? "eva:checkmark-circle-outline" : "eva:slash-outline"}
                  width={14}
                  className="text-red-500"
                />
              </div>
              <span className="text-sm">
                {chat.bloqueado ? 'Desbloquear contato' : 'Bloquear contato'}
              </span>
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

const MoreMenu = ({ chat, user, onViewHistory, onBlock }) => {
  const { t } = useTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 text-gray-500 dark:text-neutral-400 hover:bg-gray-100 dark:hover:bg-neutral-800 rounded-lg"
        >
          <Iconify icon="solar:menu-dots-bold" width={16} className="rotate-90" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={onViewHistory} className="cursor-pointer gap-2.5">
            <div className="w-7 h-7 rounded-lg bg-gray-100 dark:bg-neutral-800 flex items-center justify-center flex-shrink-0">
              <Iconify icon="solar:history-bold" width={14} className="text-gray-500 dark:text-neutral-400" />
            </div>
            <span className="text-sm">{t('chat.header.loadAllMessages')}</span>
          </DropdownMenuItem>
          {["whatsapp", "whatsapp_business"].includes(chat.canal) && onBlock && (
            <DropdownMenuItem onClick={onBlock} className="cursor-pointer gap-2.5">
              <div className="w-7 h-7 rounded-lg bg-red-50 dark:bg-red-500/10 flex items-center justify-center flex-shrink-0">
                <Iconify
                  icon={chat.bloqueado ? "eva:checkmark-circle-outline" : "eva:slash-outline"}
                  width={14}
                  className="text-red-500"
                />
              </div>
              <span className="text-sm">
                {chat.bloqueado ? 'Desbloquear contato' : 'Bloquear contato'}
              </span>
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

function ContactInfo({ chat, chatIsOnline }) {
  const { t } = useTranslation();
  const defaultImage = 'https://zapchat.nyc3.digitaloceanspaces.com/images/not-picture.png';
  const [lightboxOpen, setLightboxOpen] = useState(false);

  if (!chat) return null;

  const validaIsBrazilNumber = chat?.numeroCliente?.startsWith("55")
    ? formataNumeroCelular(chat.numeroCliente)
    : `+${chat.numeroCliente}`;

  const canal = CANAL_ICONS[chat.canal] || { icon: 'solar:chat-round-bold', color: 'text-gray-500', bg: 'bg-gray-50 dark:bg-neutral-800' };

  return (
    <>
      <ModalLightbox
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        src={[chat.fotoPerfil]}
      />
      <div className="flex items-center gap-3 min-w-0">
        {/* Avatar */}
        <div className="relative flex-shrink-0">
          <img
            onClick={() => setLightboxOpen(true)}
            className="w-9 h-9 rounded-xl object-cover cursor-pointer ring-2 ring-white dark:ring-neutral-800 shadow-sm"
            src={chat.fotoPerfil || defaultImage}
            alt={chat.nomeCliente}
            onError={(e) => { e.target.src = defaultImage }}
          />
          {chatIsOnline && (
            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-emerald-500 ring-2 ring-white dark:ring-neutral-900" />
          )}
        </div>

        {/* Info */}
        <div className="flex flex-col min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-sm font-semibold text-gray-900 dark:text-white truncate leading-tight">
              {chat.nomeCliente}
            </span>
            {chatIsOnline && (
              <span className="flex-shrink-0 inline-flex items-center px-1.5 py-0.5 rounded-md bg-emerald-50 dark:bg-emerald-500/10 text-[10px] font-semibold text-emerald-600 dark:text-emerald-400">
                {t('common.status.online')}
              </span>
            )}
            {chat.bloqueado && (
              <span className="flex-shrink-0 inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md border border-red-200 bg-red-50 text-[10px] font-semibold text-red-700 dark:bg-red-500/10 dark:text-red-400 dark:border-red-500/30">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
                Contato bloqueado
              </span>
            )}
          </div>
          <div className="flex items-center gap-1.5 mt-0.5 min-w-0">
            {["whatsapp", "whatsapp_business"].includes(chat.canal) && chat.numeroCliente && (
              <span className="text-[11px] text-gray-500 dark:text-neutral-400 truncate">
                {validaIsBrazilNumber}
              </span>
            )}
            {chat.canal === "instagram" && (
              <span className="text-[11px] text-gray-500 dark:text-neutral-400 truncate">
                @{chat.instagramUser?.profile?.username}
              </span>
            )}
            {chat.nome_canal && (
              <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md text-[10px] font-medium ${canal.bg} ${canal.color}`}>
                <Iconify icon={canal.icon} width={10} />
                {chat.nome_canal}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

// ----------------------------------------------------------------------

OneAvatar.propTypes = {
  chat: PropTypes.object
};

// Keep for backwards compat
function OneAvatar({ chat, chatIsOnline }) {
  return <ContactInfo chat={chat} chatIsOnline={chatIsOnline} />;
}

ChatHeader.propTypes = {
  chat: PropTypes.object,
  user: PropTypes.object,
  chatIsOnline: PropTypes.bool,
  onlineUsers: PropTypes.array,
};

export default function ChatHeader({
  chat,
  user,
  onlineUsers,
  chatIsOnline,
  openSidebar,
  changeOpenSidebar,
  sidebarLeft,
  changeOpenSidebarLeft,
  source,
  onCloseModal,
  onLoadAllMessages,
  mensagens = [],
  ...other
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { cliente } = useAuth();
  const { larger, smaller } = v2_useResponsive();

  const [stateModalFinalizarChat, setStateModalFinalizarChat] = useState(false);
  const [stateModalTransferirChat, setStateModalTransferirChat] = useState(false);
  const [stateModalBloquearChat, setStateModalBloquearChat] = useState(false);
  const [openModalCall, setOpenModalCall] = useState(false);
  const [stateModalFunil, setStateModalFunil] = useState(false);
  const [loadingFinalizarChat, setLoadingFinalizarChat] = useState(false);
  const [loadingBloquearChat, setLoadingBloquearChat] = useState(false);
  const [loadingTransferirChat, setLoadingTransferirChat] = useState(false);
  const [valueTransferirChat, setValueTransferirChat] = useState('');
  const [valorEscolhidoFunil, setValorEscolhidoFunil] = useState(chat.funilId);
  const [valorEscolhidoSetor, setValorEscolhidoSetor] = useState(null);
  const [valorEscolhidoUsuario, setValorEscolhidoUsuario] = useState(null);
  const [createNote, setCreateNote] = useState(false);
  const [noteText, setNoteText] = useState('');
  const { listaUsuariosTransferencia, listaSetoresTransferencia } = useSelector((state) => state.user);
  const { listaFunil, mensagens: reduxMessages } = useSelector((state) => state.chat);

  const [drawerAgendamento, setDrawerAgendamento] = useState(false);
  const [numeroCliente, setNumeroCliente] = useState();

  // Search states
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [showSearchField, setShowSearchField] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [allMessages, setAllMessages] = useState([]);
  const [allMessagesList, setAllMessagesList] = useState([]);
  const searchRef = useRef(null);

  useEffect(() => {
    setValorEscolhidoFunil(chat.funil_id);
    dispatch(getListaFunil(user.clienteId));
  }, [chat, valorEscolhidoFunil]);

  const highlightSearchTerm = (text, term) => {
    if (!term) return text;
    const regex = new RegExp(`(${term})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  };

  const loadAllMessages = async () => {
    if (!chat?.sessao || !chat?.numeroCliente) {
      enqueueSnackbar(t('chat.header.chatInfoNotFound'), { variant: 'error' });
      return;
    }
    setIsLoadingMessages(true);
    try {
      const querys = `?sessao=${chat.sessao}&numero=${chat.numeroCliente}&canal=whatsapp&limit=1000`;
      const response = await v1_actionBuscarMensagensWhatsapp(querys);
      if (response?.data?.data) {
        const textMessages = response.data.data.filter(message =>
          message.body && message.type === 'chat' && message.body.trim().length > 0
        );
        setAllMessagesList(response.data.data);
        setAllMessages(textMessages);
        setShowSearchField(true);
      } else {
        throw new Error('Resposta da API invalida');
      }
    } catch (error) {
      console.error('Erro ao carregar mensagens:', error);
      enqueueSnackbar(t('chat.errors.loadFailed'), { variant: 'error' });
    } finally {
      setIsLoadingMessages(false);
    }
  };

  const searchMessages = (term) => {
    if (!term.trim()) {
      setSearchResults([]);
      setShowSearchDropdown(false);
      return;
    }
    const results = [];
    const lowerTerm = term.toLowerCase();
    allMessages.forEach((message) => {
      if (message.body && message.body.toLowerCase().includes(lowerTerm)) {
        const body = message.body;
        const index = body.toLowerCase().indexOf(lowerTerm);
        const contextBefore = body.substring(Math.max(0, index - 30), index);
        const contextAfter = body.substring(index + term.length, Math.min(body.length, index + term.length + 30));
        const foundTerm = body.substring(index, index + term.length);
        results.push({
          id: message.id,
          body,
          contextBefore,
          contextAfter,
          foundTerm,
          timestamp: message.t || message.timestamp,
          fromMe: message.fromMe,
          type: message.type
        });
      }
    });
    setSearchResults(results);
    setShowSearchDropdown(results.length > 0);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    searchMessages(value);
  };

  const clearSearch = () => {
    setSearchTerm('');
    setSearchResults([]);
    setShowSearchDropdown(false);
    setShowSearchField(false);
    setAllMessages([]);
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('pt-BR');
  };

  const navigateToMessage = async (messageId) => {
    setShowSearchDropdown(false);
    try {
      const messageExists = reduxMessages.some(msg => msg.id === messageId);
      if (!messageExists && allMessages.length > 0) {
        dispatch(setMessagesWhatsapp(allMessagesList));
      }
      setTimeout(() => {
        const event = new CustomEvent('navigateToMessage', { detail: { messageId } });
        window.dispatchEvent(event);
      }, 100);
    } catch (error) {
      console.error('Erro ao navegar para mensagem:', error);
      enqueueSnackbar(t('chat.header.navigateError'), { variant: 'error' });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setShowSearchDropdown(false);
    setSearchResults([]);
    setSearchTerm('');
    setShowSearchField(false);
    setAllMessages([]);
    setAllMessagesList([]);
  }, [chat]);

  const handleOpenDrawerAgendamentos = () => {
    if (chat && chat.numeroCliente) {
      setNumeroCliente(chat.numeroCliente);
      setDrawerAgendamento(true);
    }
  };

  const handleChangeTipoTransferirChat = (event) => {
    setValueTransferirChat(event);
    setValorEscolhidoUsuario(null);
    setValorEscolhidoSetor(null);
  };

  const handleEscolherSetor = event => setValorEscolhidoSetor(event);
  const handleEscolherUsuario = event => setValorEscolhidoUsuario(event);
  const handleEscolherFunil = event => setValorEscolhidoFunil(event.target.value);

  const handleOpenModalFunilChat = () => {
    dispatch(getListaFunil(user.clienteId));
    setStateModalFunil(true);
  };

  const handleOpenModalFinalizarChat = () => setStateModalFinalizarChat(true);

  const handleOpenModalBloquearChat = () => setStateModalBloquearChat(true);
  const handleCloseModalBloquearChat = () => {
    if (loadingBloquearChat) return;
    setStateModalBloquearChat(false);
  };

  const handleConfirmBloquearChat = async ({ motivo } = {}) => {
    if (!chat?._id) return;
    setLoadingBloquearChat(true);
    try {
      const thunk = chat.bloqueado
        ? desbloquearChat({ chatId: chat._id, userId: user.id })
        : bloquearChat({ chatId: chat._id, userId: user.id, motivo });
      const result = await dispatch(thunk);
      if (result?.success === false) {
        enqueueSnackbar(result.message || 'Falha ao processar bloqueio', { variant: 'error' });
      } else {
        enqueueSnackbar(
          chat.bloqueado ? 'Contato desbloqueado com sucesso' : 'Contato bloqueado com sucesso',
          { variant: 'success' }
        );
        setStateModalBloquearChat(false);
      }
    } catch (err) {
      enqueueSnackbar(err?.response?.data?.message || 'Erro ao bloquear/desbloquear', { variant: 'error' });
    } finally {
      setLoadingBloquearChat(false);
    }
  };

  const handleOpenModalTransferirChat = () => {
    dispatch(getListaUsuariosTransferencia(user.clienteId));
    dispatch(getListaSetoresTransferencia(user.clienteId));
    setValorEscolhidoUsuario(null);
    setValorEscolhidoSetor(null);
    setStateModalTransferirChat(true);
  };

  const handleCloseModalFinalizarChat = () => {
    setValorEscolhidoUsuario(null);
    setValorEscolhidoSetor(null);
    setStateModalFinalizarChat(false);
  };

  const handleCloseModalTransferirChat = () => {
    setStateModalTransferirChat(false);
    setCreateNote(false);
    setNoteText('');
  };

  const handleCloseModalFunilChat = () => setStateModalFunil(false);

  const handleTransferirChat = async (sendMessage, transferProprietary, noteText = '') => {
    setLoadingTransferirChat(true);
    let data = {
      id: chat._id,
      usuarioId: user.id,
      direcionaSetores: valorEscolhidoSetor,
      direcionaUsuarios: valorEscolhidoUsuario,
      sendMessage,
      transferProprietary
    };

    try {
      await v2_actionTransferChatInit(chat._id, data);
      if (noteText && noteText.trim() !== '') {
        try {
          await actionCriarNotas(chat._id, {
            nota: { body: noteText.trim(), usuario_id: user.id, date: new Date() }
          });
        } catch (noteError) {
          console.error('Erro ao criar nota:', noteError);
        }
      }
      dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
      dispatch(getChatsPendente(user.clienteId, user.id, user.setorId, 10, true));
      setStateModalTransferirChat(false);
      setLoadingTransferirChat(false);
      setCreateNote(false);
      setNoteText('');
      navigate(PATH_CHAT.chat);
      dispatch(setChatInfo(null));
      dispatch(setMessages([]));
    } catch (error) {
      // handle silently
    }
  };

  const handleAdicionarNoFunil = async (funilId) => {
    try {
      await getActionCriarFunil({ chatId: chat._id, usuarioId: user.id, funilId });
      setValorEscolhidoFunil(funilId);
      enqueueSnackbar(t('chat.header.funnelChanged'), { variant: 'success' });
    } catch (error) {
      console.error('erro ao adicionar no funil', error);
    }
  };

  const handleFinalizarChat = async (chatId, sendMessage, statusOrigin) => {
    try {
      setLoadingFinalizarChat(true);
      dispatch(removeChatFromList({ chatId, status: statusOrigin }));
      await v2_actionFinalizarChat(chatId, { userId: user.id, sendMessage });
      dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
      dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, true));
      setStateModalFinalizarChat(false);
      setLoadingFinalizarChat(false);
      dispatch(setChatInfo(null));

      if (source === 'chat.supervisionar') {
        onCloseModal();
        return;
      }
      return navigate(`${PATH_CHAT.chat.root}`);
    } catch (error) {
      setLoadingFinalizarChat(false);
      dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
      enqueueSnackbar(t('chat.header.finalizeError'), { variant: "error" });
    }
  };

  async function handleAceitar() {
    try {
      await getActionAceitarChat({ chatId: chat._id, usuarioId: user.id, action: "supervisao" });
      dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, true));
      enqueueSnackbar(t('chat.header.chatAccepted'), { variant: 'success' });
    } catch (error) {
      console.error(error);
    }
  }

  // Action buttons for desktop
  const ActionButton = ({ icon, tooltip, onClick, disabled, loading }) => (
    <Tooltip title={tooltip}>
      <Button
        variant="ghost"
        size="icon"
        disabled={disabled}
        className="h-8 w-8 rounded-lg text-gray-500 dark:text-neutral-400 hover:bg-gray-100 dark:hover:bg-neutral-800 hover:text-gray-700 dark:hover:text-neutral-200 disabled:opacity-40"
        onClick={onClick}
      >
        {loading ? (
          <CircularProgress size={14} color="inherit" />
        ) : (
          <Iconify icon={icon} width={16} />
        )}
      </Button>
    </Tooltip>
  );

  return (
    <>
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2.5 bg-white dark:bg-neutral-900 border-b border-gray-100 dark:border-neutral-800 flex-shrink-0">
        {/* Left: back button + contact info */}
        <div className="flex items-center gap-2 min-w-0">
          {!larger.lg && (
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 rounded-lg text-gray-500 dark:text-neutral-400 hover:bg-gray-100 dark:hover:bg-neutral-800 flex-shrink-0"
              onClick={() => changeOpenSidebarLeft()}
            >
              <Iconify width={14} icon={sidebarLeft ? "solar:arrow-right-linear" : "solar:arrow-left-linear"} />
            </Button>
          )}

          <ContactInfo chat={chat} chatIsOnline={chatIsOnline} />
        </div>

        {/* Right: actions */}
        {smaller.lg ? (
          <div className="flex items-center gap-1">
            <MobileMenu
              onTransfer={handleOpenModalTransferirChat}
              onSchedule={handleOpenDrawerAgendamentos}
              onFinalize={handleOpenModalFinalizarChat}
              onCatch={handleAceitar}
              onCall={() => setOpenModalCall(true)}
              onBlock={handleOpenModalBloquearChat}
              chat={chat}
              user={user}
            />
            <MoreMenu
              chat={chat}
              user={user}
              onViewHistory={() => dispatch(getMensagensWhatsapp(chat.sessao, chat.numeroCliente))}
              onBlock={handleOpenModalBloquearChat}
            />
          </div>
        ) : (
          <div className="flex items-center gap-0.5">
            {!showSearchField && (
              <ActionButton
                icon="solar:magnifer-linear"
                tooltip={t('chat.header.searchMessages')}
                onClick={loadAllMessages}
                disabled={isLoadingMessages}
                loading={isLoadingMessages}
              />
            )}

            {user.level === 'root' && larger.lg && (
              <ActionButton
                icon="fa-solid:hand-rock"
                tooltip={t('chat.header.catchChat')}
                onClick={handleAceitar}
              />
            )}

            {larger.lg && (
              <ActionButton
                icon="mingcute:transfer-fill"
                tooltip={t('chat.header.transferChat')}
                onClick={handleOpenModalTransferirChat}
              />
            )}

            <DrawerAgendamentos
              source="headerChat"
              numero={chat.numeroCliente}
              isEdit={false}
              typeButton="icon"
            />

            {chat.statusRoom !== "Finalizado" && larger.lg && (
              <ActionButton
                icon="mdi:chat-remove"
                tooltip={t('chat.header.finalizeChat')}
                onClick={handleOpenModalFinalizarChat}
              />
            )}

            <MoreMenu
              chat={chat}
              user={user}
              onViewHistory={() => dispatch(getMensagensWhatsapp(chat.sessao, chat.numeroCliente))}
              onBlock={handleOpenModalBloquearChat}
            />

            <div className="w-px h-5 bg-gray-200 dark:bg-neutral-700 mx-1" />

            <ActionButton
              icon={openSidebar ? "solar:sidebar-minimalistic-bold" : "solar:sidebar-minimalistic-outline"}
              tooltip={openSidebar ? t('chat.header.hideInfo') : t('chat.header.showInfo')}
              onClick={() => changeOpenSidebar(!openSidebar)}
            />
          </div>
        )}
      </div>

      {/* Search bar */}
      {showSearchField && (
        <div className="px-4 py-2 bg-gray-50 dark:bg-neutral-900/80 border-b border-gray-100 dark:border-neutral-800 relative" ref={searchRef}>
          <div className="relative">
            <Iconify
              icon="solar:magnifer-linear"
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-neutral-500 w-4 h-4 pointer-events-none"
            />
            <Input
              placeholder={t('chat.header.searchMessagesPlaceholder')}
              value={searchTerm}
              onChange={handleSearchChange}
              autoFocus
              className="w-full pl-10 pr-10 h-9 bg-white dark:bg-neutral-800 border-gray-200 dark:border-neutral-700 rounded-lg text-sm placeholder:text-gray-400 dark:placeholder:text-neutral-500 focus:border-violet-400 focus:ring-violet-400/20"
            />
            <button
              onClick={clearSearch}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-neutral-300 transition-colors"
            >
              <Iconify icon="solar:close-circle-bold" className="w-4 h-4" />
            </button>
          </div>

          {/* Search results dropdown */}
          {showSearchDropdown && searchResults.length > 0 && (
            <Card className="absolute top-full left-2 right-2 z-50 max-h-72 overflow-auto mt-1 shadow-lg border-gray-200 dark:border-neutral-700 rounded-xl p-0">
              {searchResults.map((result, index) => (
                <div key={result.id}>
                  <div
                    className="px-3.5 py-2.5 cursor-pointer hover:bg-gray-50 dark:hover:bg-neutral-800 transition-colors"
                    onClick={() => navigateToMessage(result.id)}
                  >
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-[11px] text-gray-400 dark:text-neutral-500">{formatDate(result.timestamp)}</span>
                      <span className="inline-flex items-center px-1.5 py-0.5 rounded-md text-[10px] font-medium bg-violet-50 dark:bg-violet-500/10 text-violet-600 dark:text-violet-400">
                        {result.fromMe ? t('chat.header.you') : chat?.nomeCliente}
                      </span>
                    </div>
                    <p className="text-sm text-gray-700 dark:text-neutral-300 leading-relaxed">
                      {result.contextBefore && (
                        <span className="text-gray-400 dark:text-neutral-500">...{result.contextBefore}</span>
                      )}
                      <span
                        className="font-semibold bg-violet-100 dark:bg-violet-500/20 text-violet-700 dark:text-violet-300 px-1 py-0.5 rounded"
                        dangerouslySetInnerHTML={{ __html: highlightSearchTerm(result.foundTerm, searchTerm) }}
                      />
                      {result.contextAfter && (
                        <span className="text-gray-400 dark:text-neutral-500">{result.contextAfter}...</span>
                      )}
                    </p>
                  </div>
                  {index < searchResults.length - 1 && (
                    <div className="border-b border-gray-100 dark:border-neutral-800 mx-3" />
                  )}
                </div>
              ))}
            </Card>
          )}
        </div>
      )}

      {/* Modals */}
      <ModalFinalizarChat
        stateModalFinalizarChatProps={stateModalFinalizarChat}
        closeModalFinalizarChat={handleCloseModalFinalizarChat}
        finalizarChat={(value) => handleFinalizarChat(chat._id, value, "Finalizado")}
        user={user}
        loadingFinalizarChat={loadingFinalizarChat}
      />

      <ModalBloquearChat
        open={stateModalBloquearChat}
        onClose={handleCloseModalBloquearChat}
        onConfirm={handleConfirmBloquearChat}
        loading={loadingBloquearChat}
        mode={chat.bloqueado ? 'unblock' : 'block'}
        canal={chat.canal}
        numeroCliente={chat.numeroCliente}
      />

      <ModalFunilChat
        closeModalFunilChat={handleCloseModalFunilChat}
        valorEscolhidoFunilProps={valorEscolhidoFunil}
        handleFunil={event => handleEscolherFunil(event)}
        listaFunilProps={listaFunil || []}
        stateModalFunilProps={stateModalFunil}
        submitFunilChat={handleAdicionarNoFunil}
      />

      <ModalTransferirChat
        chat={chat}
        stateModalTransferirChatProps={stateModalTransferirChat}
        closeModalTransferirChat={handleCloseModalTransferirChat}
        actionTipoTransferencia={event => handleChangeTipoTransferirChat(event)}
        valueTransferirChat={valueTransferirChat}
        listaUsuariosProps={listaUsuariosTransferencia}
        listaSetoresProps={listaSetoresTransferencia}
        valorEscolhidoSetorProps={valorEscolhidoSetor}
        valorEscolhidoUsuarioProps={valorEscolhidoUsuario}
        handleSetor={event => handleEscolherSetor(event)}
        handleUsuario={event => handleEscolherUsuario(event)}
        submitTranferirChat={(value, transferProprietary, noteText) => handleTransferirChat(value, transferProprietary, noteText)}
        user={user}
        loadingTransferirChat={loadingTransferirChat}
        onlineUsers={onlineUsers}
        cliente={cliente}
        createNote={createNote}
        noteText={noteText}
        changeCreateNote={setCreateNote}
        changeNoteText={setNoteText}
      />

      <ModalCall
        open={openModalCall}
        onClose={() => setOpenModalCall(false)}
      />
    </>
  );
}
